import React from 'react';
import styled from 'styled-components';

import { Alert, ModalDialog, spaceMixin } from '@zillow/constellation';
import PropTypes from 'prop-types';

// Hiding scrollbars and overflow in the body container to eliminate a double scrollbar bug
// Even with overflow hidden, the scrollbar on the parent container still appears (even though it doesn't move much),
// so it is necessary to explicitly hide it
//         scrollbar-width: none;  --- Firefox
//         -ms-overflow-style: none;  --- IE
//         &::-webkit-scrollbar {
//             display: none; --- Chrome, Safari, Edge
//         }
const StyledModalDialog = styled(ModalDialog)`
  & section > div {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
    & ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const StyledIframe = styled('iframe')`
  flex-grow: 1;
  height: 100%;
  width: 100%;
  overflow: hidden;
  @media print {
    display: none;
  }
`;

const StyledAlert = styled(Alert)`
  margin-top: ${spaceMixin('xs')};
  margin-bottom: ${spaceMixin('sm')};
`;

const FAILED_DOCUMENT_VIEW_TEXT =
  'Oops. Something went wrong while viewing the income verification document. Please refresh the page to try again.';

export default function UploadedDocumentViewer({ documentEditorUrl, isOpen, handleOnClose }) {
  return (
    <StyledModalDialog
      className="documentViewerModal"
      isOpen={isOpen}
      onClose={handleOnClose}
      fullScreen
      shouldCloseOnOutsideClick={false}
      body={
        documentEditorUrl ? (
          <StyledIframe src={documentEditorUrl} className="documentViewer" />
        ) : (
          <StyledAlert className="failedDocumentViewAlert" appearance="warning" body={FAILED_DOCUMENT_VIEW_TEXT} />
        )
      }
    />
  );
}

UploadedDocumentViewer.propTypes = {
  documentEditorUrl: PropTypes.string,
  isOpen: PropTypes.bool,
  handleOnClose: PropTypes.func,
};
